import { GET_LABELS_FAILURE, GET_LABELS_REQUEST, GET_LABELS_SUCCESS, labelsInitialState } from "actions/labelsActions";

import { DONE, EMPTY, ERROR, IN_PROGRESS } from "constants/Status";


const initialLabelsState = { status: EMPTY, ...labelsInitialState };

export const labelsReducer = (
    state = initialLabelsState,
    action: any
): any => {
    const newState = reduceLabelsRequest(state, action);
    return newState;
};

const reduceLabelsRequest = (state: any, action: any): any => {
    switch (action.type) {
        case GET_LABELS_SUCCESS:
            return {
                ...state,
                status: DONE,
                labels: action.response,
            };
        case GET_LABELS_REQUEST:
            return {
                ...state,
                status: IN_PROGRESS,
            };
        case GET_LABELS_FAILURE:
            return {
                status: ERROR,
                error: action.error,
            };
        default:
            return state;
    }
};

export default {
    labelsReducer,
};